import { Injectable } from "@angular/core";
import { Headers, Http } from "@angular/http";
import { AppConstants } from "../core/app.constants";
import { environment } from "environments/environment";
import { Observable } from "rxjs/Observable";
import { DocumentResponse } from "app/core/core.component";

@Injectable()
export class DocumentService {
	constructor(private http: Http) {}

	getUserDocuments(srmToken: string, userId: number): Observable<{ list: DocumentResponse[] }> {
		var url = environment.REST_SERVICE_BASE_URL + "/documents/" + userId;
		url = AppConstants.urlForNoCache(url);
		var headers = new Headers();
		headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

		return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
	}

	getDocuments(srmToken: string): Observable<{ list: DocumentResponse[] }> {
		var url = environment.REST_SERVICE_BASE_URL + "/documents";
		url = AppConstants.urlForNoCache(url);
		var headers = new Headers();
		headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

		return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
	}

	uploadUserDocuments(srmToken: string, formData: FormData) {
		var url = environment.REST_SERVICE_BASE_URL + "/documents/uploadUserDocuments";
		url = AppConstants.urlForNoCache(url);
		var headers = new Headers();
		headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

		return this.http.post(url, formData, { headers: headers }).map((responseData) => responseData.json());
	}

	getLastDocument(srmToken: string): Observable<{ object: DocumentResponse }> {
		var url = environment.REST_SERVICE_BASE_URL + "/documents/lastDocument";
		url = AppConstants.urlForNoCache(url);
		var headers = new Headers();
		headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

		return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
	}

	getDocumentContent(srmToken: string, documentId: string) {
		var url = environment.REST_SERVICE_BASE_URL + "/documents/content/" + documentId;
		url = AppConstants.urlForNoCache(url);
		var headers = new Headers();
		headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

		return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
	}

	getDocumentUploadModes(srmToken: string) {
		var url = environment.REST_SERVICE_BASE_URL + "/documents/uploadModes";
		url = AppConstants.urlForNoCache(url);
		var headers = new Headers();
		headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

		return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
	}

	uploadDocuments(srmToken: string, formData: FormData) {
		var url = environment.REST_SERVICE_BASE_URL + "/documents/uploadDocuments";
		url = AppConstants.urlForNoCache(url);
		var headers = new Headers();
		headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

		return this.http.post(url, formData, { headers: headers }).map((responseData) => responseData.json());
	}

	deleteDocument(srmToken: string, documentId: string) {
		var url = environment.REST_SERVICE_BASE_URL + "/documents/" + documentId;
		url = AppConstants.urlForNoCache(url);
		var headers = new Headers();
		headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

		return this.http.delete(url, { headers: headers }).map((responseData) => responseData.json());
	}

	markDocumentAsRead(srmToken: string, documentId: string) {
		var url = environment.REST_SERVICE_BASE_URL + "/documents/read";
		url = AppConstants.urlForNoCache(url);
		var headers = new Headers();
		headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
		headers.append("Content-Type", "application/json");

		var body = JSON.stringify({ documentId: documentId });
		return this.http.post(url, body, { headers: headers }).map((responseData) => responseData.json());
	}
}



// WEBPACK FOOTER //
// ./src/app/service/document.service.ts